<div [formGroup]="incidentEditForm">
  <div class="row mb-3">
    <div class="col-12">
      <label class="form-label" for="statusServiceId">{{ 'i18n.domain.incidents.fields.service' | translate }}</label>
      @if (isReadOnly) {
        <input class="form-control e-textbox" [value]="incidentEditForm.controls.statusServiceId.value" disabled />
      } @else {
        <ejs-dropdownlist id="statusServiceId"
                          formControlName="statusServiceId"
                          [dataSource]="serviceDropdownItems"
                          [fields]="serviceDropdownFields"
                          [placeholder]="'i18n.domain.incidents.fields.select-service' | translate">
        </ejs-dropdownlist>
      }
    </div>
  </div>
  <div class="row mb-3">
    <div class="col-12">
      <label class="form-label" for="status">{{ 'i18n.domain.incidents.fields.status' | translate }}</label>
      @if (isReadOnly) {
        <input class="form-control e-textbox" disabled />
      } @else {
        <ejs-dropdownlist id="status"
                          formControlName="status"
                          [dataSource]="statusOptions"
                          [fields]="dropdownFields">
        </ejs-dropdownlist>
      }
    </div>
  </div>
  <div class="row mb-3">
    <div class="col-12">
      <label appMarkAsterisk class="form-label" for="description">{{ 'i18n.domain.incidents.fields.description' | translate }}</label>
      @if (isReadOnly) {
        <input class="form-control e-textbox" [value]="incidentEditForm.controls.description.value" disabled />
      } @else {
        <textarea id="description" class="form-control e-textbox" formControlName="description" rows="2"
          [class.is-invalid]="incidentEditForm.controls.description.invalid && incidentEditForm.controls.description.touched"
          [placeholder]="'i18n.domain.incidents.fields.description-placeholder' | translate"
          maxlength="250"></textarea>
        @if (incidentEditForm.controls.description.invalid && incidentEditForm.controls.description.touched) {
          <div class="invalid-feedback d-block">
            @if (incidentEditForm.controls.description.errors?.['required']) {
              {{ 'i18n.validation.required' | translate }}
            } @else if (incidentEditForm.controls.description.errors?.['maxlength']) {
              {{ 'i18n.domain.incidents.validation.description-maxlength' | translate }}
            }
          </div>
        }
      }
    </div>
  </div>
  <div class="row mb-3">
    <div class="col-12">
      <ejs-checkbox label="{{ 'i18n.domain.incidents.fields.sendNotification' | translate }}"
                    formControlName="sendNotification"
                    [disabled]="isReadOnly"
                    cssClass="checkbox-large"></ejs-checkbox>
    </div>
  </div>

  @if (incidentEditForm.controls.sendNotification.value && !isReadOnly) {
    <div class="row mb-3">
      <div class="col-12">
        <label class="form-label">{{ 'i18n.domain.incidents.fields.clients' | translate }}</label>
        <app-multi-select-filter [getDataFunction]="searchClients.bind(this)"
                                 [values]="selectedClientIds"
                                 (valuesChange)="onSelectedClientsChanged($event)"
                                 [type]="MultiSelectFilterType.MultiSelectItem"
                                 [closePopupOnSelect]="false"
                                 [placeholder]="'i18n.domain.incidents.fields.select-clients' | translate">
        </app-multi-select-filter>
      </div>
    </div>
  }

  @if (messagesArray.length > 0) {
    <div class="row mb-3">
      <div class="col-12">
        <label class="form-label">{{ 'i18n.domain.incidents.fields.messages' | translate }}</label>
        <ejs-tab [animation]="tabAnimation">
          <e-tabitems>
            @for (msgGroup of messagesArray.controls; track msgGroup; let i = $index) {
              <e-tabitem>
                <ng-template #headerText>
                  <span [class.tab-header-invalid]="msgGroup.controls.message.invalid">
                    {{ msgGroup.controls.language.value | uppercase }}
                  </span>
                </ng-template>
                <ng-template #content>
                  <div [formGroup]="msgGroup" class="p-3">
                    <textarea class="form-control e-textbox" formControlName="message" rows="4"
                      [class.is-invalid]="msgGroup.controls.message.invalid && msgGroup.controls.message.touched"
                      [placeholder]="'i18n.domain.incidents.fields.message-placeholder' | translate"
                      [attr.readonly]="isReadOnly ? '' : null"></textarea>
                    @if (msgGroup.controls.message.invalid && msgGroup.controls.message.touched) {
                      <div class="invalid-feedback d-block">
                        {{ 'i18n.validation.required' | translate }}
                      </div>
                    }
                  </div>
                </ng-template>
              </e-tabitem>
            }
          </e-tabitems>
        </ejs-tab>
      </div>
    </div>
  }
</div>
